import { tss } from 'tss-react';

import Filters from 'components/desktop/ShoppingCart/Search/misc/Filters';
import List from 'components/desktop/ShoppingCart/Search/misc/List';
import MergeButton from 'components/desktop/ShoppingCart/Search/misc/MergeButton';
import STATUS from 'types/ShoppingCart/Status';

interface IProps {
	status: STATUS;
}

const GeneralTab = ({ status }: IProps) => {
	const { classes } = useStyles();

	return (
		<div className={classes.container}>
			<div className={classes.controls}>
				<Filters />
				<MergeButton />
			</div>
			<List status={status} />
		</div>
	);
};

export default GeneralTab;

export const useStyles = tss.create({
	container: {
		marginTop: '20px',
	},
	controls: {
		display: 'none',
		justifyContent: 'space-between',
	},
});
